import script from "./QTransportItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QTransportItem.vue?vue&type=script&setup=true&lang=js"

import "./QTransportItem.vue?vue&type=style&index=0&id=2612e31c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2612e31c"]])

export default __exports__